/* FM · Pay with Monkees (cart drawer + cart page). Ported from the live cart-drawer; markup in snippets/fm-monkees-pay.liquid.
   App proxy endpoints (Friki Monkey Trade Engine): /apps/trade/balance, /apps/trade/redeem/release-abandoned,
   /apps/trade/redeem/create-checkout. */
(function () {
  if (window.__fmMonkeesPayInit) return;
  window.__fmMonkeesPayInit = true;

  var CACHE_KEY = 'fm_mkc_v1';
  var TAG_ONLY = ['monkees_only', 'trade_only'];
  var cache = {};
  try { cache = JSON.parse(sessionStorage.getItem(CACHE_KEY) || '{}'); } catch (e) { cache = {}; }
  function saveCache() { try { sessionStorage.setItem(CACHE_KEY, JSON.stringify(cache)); } catch (e) { /* storage unavailable */ } }

  var $ = function (id) { return document.getElementById(id); };
  function esc(s) { s = String(s == null ? '' : s); return s.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;').replace(/'/g, '&#39;'); }
  function nf(n) { return (Number(n) || 0).toLocaleString(document.documentElement.lang || undefined); }
  function msg(key) { var m = $('fmd-pay-modal'); return (m && m.dataset[key]) || ''; }
  function fill(t, v) { Object.keys(v || {}).forEach(function (k) { t = t.split('%' + k + '%').join(v[k]); }); return t; }
  function note(text, kind) { var n = $('fmd-pay-note'); if (!n) return; n.textContent = text || ''; n.className = 'fmd-pay__note' + (text ? ' is-' + (kind || 'warn') : ''); }
  function rootUrl(path) { var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/'; return root + path; }

  function termsOk() {
    var cb = $('agreementCheckbox');
    if (!cb || cb.checked) return true;
    cb.setCustomValidity(msg('termsRequired') || cb.validationMessage || ' ');
    cb.reportValidity();
    cb.addEventListener('change', function clear() { cb.setCustomValidity(''); cb.removeEventListener('change', clear); });
    return false;
  }

  async function fetchProduct(handle) {
    if (cache[handle]) return cache[handle];
    try {
      var r = await fetch('/products/' + encodeURIComponent(handle) + '.js', { credentials: 'same-origin' });
      if (!r.ok) { cache[handle] = null; return null; }
      var d = await r.json();
      cache[handle] = { tags: (d.tags || []).map(function (t) { return String(t).toLowerCase(); }) };
      return cache[handle];
    } catch (e) { cache[handle] = null; return null; }
  }

  async function classify(items) {
    var lines = await Promise.all(items.map(async function (i) {
      var entry = { title: i.product_title || i.title || '', qty: i.quantity || 1 };
      var handle = (i.handle || '').toLowerCase();
      var p = handle ? await fetchProduct(handle) : null;
      if (!p || !p.tags) return { kind: 'cash', line: 0, entry: entry };
      var line = i.original_line_price || i.line_price || 0;
      if (p.tags.some(function (t) { return TAG_ONLY.indexOf(t) >= 0; })) return { kind: 'only', line: line, entry: entry };
      if (p.tags.indexOf('monkees_redeemable') >= 0) return { kind: 'redeemable', line: line, entry: entry };
      return { kind: 'cash', line: 0, entry: entry };
    }));
    saveCache();
    var out = { onlyCents: 0, redeemableCents: 0, monkeesItems: [], cashItems: [] };
    lines.forEach(function (l) {
      if (l.kind === 'only') { out.onlyCents += l.line; out.monkeesItems.push(l.entry); }
      else if (l.kind === 'redeemable') { out.redeemableCents += l.line; out.monkeesItems.push(l.entry); }
      else out.cashItems.push(l.entry);
    });
    return out;
  }

  function renderSplit(isMixed, monkeesItems, cashItems) {
    var panel = $('fmd-pay-split'); if (!panel) return;
    panel.hidden = !isMixed; if (!isMixed) return;
    var fillList = function (id, arr) {
      var ul = $(id); if (!ul) return;
      var MAX = 4;
      var lis = arr.slice(0, MAX).map(function (it) { return '<li>' + esc(it.qty + '× ' + it.title) + '</li>'; });
      if (arr.length > MAX) lis.push('<li class="fmd-pay__split-more">' + esc(fill(msg('splitMore') || '+%n%', { n: arr.length - MAX })) + '</li>');
      ul.innerHTML = lis.join('');
    };
    fillList('fmd-pay-split-monkees', monkeesItems);
    fillList('fmd-pay-split-cash', cashItems);
  }

  function setMode(mode) {
    var modal = $('fmd-pay-modal'); if (modal) modal.dataset.mode = mode;
    var confirm = $('fmd-pay-confirm'); if (!confirm) return;
    confirm.hidden = false;
    confirm.disabled = mode === 'blocked';
    confirm.textContent = mode === 'login' ? msg('login') : msg('continueLabel');
  }

  function show(el, visible) { if (el) el.hidden = !visible; }
  function text(id, value) { var el = $(id); if (el) el.textContent = value; }

  async function openModal() {
    var modal = $('fmd-pay-modal'); if (!modal) return;
    note('');
    var minR = parseInt(modal.dataset.min || '100', 10);
    if (!modal.open) modal.showModal();
    note(msg('loading'), 'warn');
    setMode('blocked');

    modal.dataset.idem = 'co-' + ((window.crypto && crypto.randomUUID) ? crypto.randomUUID() : (Date.now() + '-' + Math.random().toString(16).slice(2)));

    try { await fetch('/apps/trade/redeem/release-abandoned', { method: 'POST', credentials: 'same-origin' }); } catch (e) { /* best effort */ }

    var bal = null, c = null;
    try { var br = await fetch('/apps/trade/balance', { credentials: 'same-origin' }); bal = br.ok ? await br.json() : null; } catch (e) { bal = null; }
    try { c = await (await fetch(rootUrl('cart.js'), { credentials: 'same-origin' })).json(); } catch (e) { c = null; }

    if (!bal || bal.logged_in === false) { note(msg('notLogged'), 'err'); setMode('login'); return; }
    if (!c || !c.items || !c.items.length) { note(msg('error'), 'err'); setMode('blocked'); return; }

    var confirmedV = bal.confirmed || 0, provV = bal.provisional || 0, totalBal = confirmedV + provV;
    var available = Number.isFinite(bal.available) ? bal.available : totalBal;
    var held = Number(bal.held) || 0;

    var cls = await classify(c.items);
    var onlyCents = cls.onlyCents;
    var eligible = onlyCents + cls.redeemableCents;
    var maxMonkees = Math.min(available, eligible);
    var sliderMin = onlyCents > 0 ? onlyCents : minR;

    var euroAllowed = onlyCents === 0;
    show($('fmd-pay-euros'), euroAllowed);
    show($('fmd-pay-cancel'), !euroAllowed);

    text('fmd-pay-total', nf(totalBal));
    text('fmd-pay-confirmed', nf(confirmedV));
    text('fmd-pay-provisional', nf(provV));
    text('fmd-pay-cart-monkees', nf(c.total_price));

    var isMixed = cls.monkeesItems.length > 0 && cls.cashItems.length > 0;
    show($('fmd-pay-eligible-row'), isMixed);
    text('fmd-pay-eligible', nf(eligible));
    renderSplit(isMixed, cls.monkeesItems, cls.cashItems);

    var sliderBlock = $('fmd-pay-slider-block'), locked = $('fmd-pay-locked');
    var summary = $('fmd-pay-summary'), cartRow = $('fmd-pay-cart-row');

    if (maxMonkees < sliderMin) {
      var heldWouldUnblock = held > 0 && Math.min(available + held, eligible) >= sliderMin;
      if (heldWouldUnblock) note(fill(msg('heldReserved'), { held: nf(held), available: nf(available) }), 'err');
      else if (onlyCents > 0) note(fill(msg('needOnly'), { need: nf(onlyCents), have: nf(available) }), 'err');
      else if (eligible < sliderMin) note(fill(msg('eligibleBelowMin'), { eligible: nf(eligible), min: nf(sliderMin) }), 'err');
      else note(fill(msg('minRequired'), { min: nf(sliderMin), have: nf(available) }), 'err');
      show(sliderBlock, false); show(summary, false); show(locked, false); show(cartRow, true);
      setMode('blocked');
      return;
    }

    var slider = $('fmd-pay-slider');
    if (slider) {
      slider.step = (maxMonkees - sliderMin) >= 5000 ? 10 : 1;
      slider.min = sliderMin; slider.max = maxMonkees; slider.value = maxMonkees;
      slider.setAttribute('value', maxMonkees);
    }
    text('fmd-pay-slider-min', nf(sliderMin));
    text('fmd-pay-slider-max', nf(maxMonkees));
    text('fmd-pay-amount', nf(maxMonkees));

    var hasRange = maxMonkees > sliderMin;
    if (hasRange) {
      show(summary, false); show(cartRow, true); show(sliderBlock, true); show(locked, false);
    } else {
      show(summary, true); text('fmd-pay-summary-amount', nf(maxMonkees));
      show(cartRow, false); show(sliderBlock, false); show(locked, onlyCents > 0);
    }

    if (held > 0) note(fill(msg('heldNote'), { held: nf(held) }), 'warn');
    else if (onlyCents === 0 && hasRange) note(msg('partialRest'), 'warn');
    else note('');
    setMode('pay');
  }

  function humanError(code) {
    var map = {
      monkees_only_products_not_fully_covered: 'errOnlyNotCovered',
      insufficient_balance: 'errInsufficient',
      b2b_cannot_redeem: 'b2b',
      pack_not_redeemable_with_monkees: 'errPack',
      no_monkees_eligible_items: 'errNoEligible'
    };
    return (map[code] && msg(map[code])) || msg('error');
  }

  async function confirmPay() {
    var modal = $('fmd-pay-modal'); if (!modal) return;
    if (modal.dataset.mode === 'login') { window.location.href = modal.dataset.loginUrl || '/account/login'; return; }
    var confirm = $('fmd-pay-confirm');
    var slider = $('fmd-pay-slider');
    var monkees = parseInt(slider && slider.value, 10);
    if (!Number.isInteger(monkees) || monkees <= 0) return;
    var orig = confirm ? confirm.textContent : '';
    var restore = function () { if (confirm) { confirm.disabled = false; confirm.textContent = orig; } };
    if (confirm) { confirm.disabled = true; confirm.textContent = '…'; }
    note('');
    try {
      var c = await (await fetch(rootUrl('cart.js'), { credentials: 'same-origin' })).json();
      var items = c.items.map(function (i) { return { variantGid: 'gid://shopify/ProductVariant/' + i.variant_id, quantity: i.quantity }; });
      var res = await fetch('/apps/trade/redeem/create-checkout', {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ cartItems: items, monkeesRequested: monkees, idempotencyKey: modal.dataset.idem })
      });
      if (!res.ok) {
        var e = await res.json().catch(function () { return {}; });
        note(humanError(e.error), 'err');
        restore();
        return;
      }
      var out = await res.json();
      if (out && out.invoiceUrl) { window.location.href = out.invoiceUrl; }
      else { note(msg('error'), 'err'); restore(); }
    } catch (err) {
      note(msg('error'), 'err');
      restore();
    }
  }

  document.addEventListener('click', function (e) {
    var t = e.target; if (!(t instanceof Element)) return;

    var checkout = t.closest('#CartDrawer-Checkout, #checkout');
    if (checkout && !termsOk()) { e.preventDefault(); e.stopPropagation(); return; }

    var opener = t.closest('[data-fm-monkees-open]');
    if (opener) {
      e.preventDefault();
      if (opener.getAttribute('data-busy') === '1' || !termsOk()) return;
      opener.setAttribute('data-busy', '1');
      openModal().finally(function () { opener.removeAttribute('data-busy'); });
      return;
    }
    if (t.closest('#fmd-pay-confirm')) { e.preventDefault(); confirmPay(); return; }
    if (t.closest('#fmd-pay-euros')) { e.preventDefault(); window.location.href = rootUrl('checkout'); return; }
    if (t.closest('#fmd-pay-cancel') || t.closest('#fmd-pay-x')) {
      var m = $('fmd-pay-modal'); if (m && m.open) m.close();
    }
  }, true);

  document.addEventListener('input', function (e) {
    var t = e.target;
    if (t && t.id === 'fmd-pay-slider') text('fmd-pay-amount', nf(t.value));
  });
})();
